import { axiosBase } from "utils";

export function portregistryListService() {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: "/portregistry",
  });
}

export function portregistryListByIdService(id) {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: "/portregistry/" + id,
  });
}

export function portregistryCreateService(values) {
  const axios = axiosBase.create();
  return axios({
    method: "POST",
    url: "/portregistry",
    data: {
      deviceregistry: values.deviceregistry,
      datadrop: values.datadrop,
      interface: values.interface,
      port_speed: values.port_speed,
      officenumber: values.officenumber,
      deviceport: values.deviceport || "DEVICE_AND_PHONE",
      specialPort: values.specialPort === true,
      status: values.status || "ENABLED",
      description: values.description || null,
      connected_portregistry: values.connected_portregistry || null,
      connection_note: values.connection_note || null,
    },
  });
}

export function portregistryUpdateService(id, values) {
  const axios = axiosBase.create();
  return axios({
    method: "PATCH",
    url: "/portregistry/" + id,
    data: {
      deviceregistry: values.deviceregistry,
      datadrop: values.datadrop,
      interface: values.interface,
      port_speed: values.port_speed,
      officenumber: values.officenumber,
      deviceport: values.deviceport || "DEVICE_AND_PHONE",
      specialPort: values.specialPort === true,
      status: values.status || "ENABLED",
      description: values.description || null,
      connected_portregistry: values.connected_portregistry || null,
      connection_note: values.connection_note || null,
    },
  });
}

export function toggleShutdownService(id, type) {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: `/portregistry/toggle-shutdown/${id}?type=${type}`,
  });
}

export function switchportInfoService(id, execute) {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: `/portregistry/switchport-info/${id}`,
    params: {
      execute: execute && execute === true ? true : false,
    },
  });
}

export function executeShutdownService(id, type) {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: `/portregistry/execute-shutdown/${id}?type=${type}`,
  });
}

export function portregistryDeleteService(id) {
  const axios = axiosBase.create();
  return axios({
    method: "DELETE",
    url: "/portregistry/" + id,
  });
}

export function portregistrySearchService(q) {
  const axios = axiosBase.create();
  if (q === "") {
    return axios({
      method: "GET",
      url: "/portregistry",
    });
  } else {
    return axios({
      method: "GET",
      url: "/portregistry/search?q=" + q,
    });
  }
}

export function portregistryByDeviceService(deviceregistryId, excludeId) {
  const axios = axiosBase.create();
  const params = excludeId ? { exclude: excludeId } : {};
  return axios({
    method: "GET",
    url: `/portregistry/by-device/${deviceregistryId}`,
    params,
  });
}
